import PropTypes from "prop-types";
import { useState, useEffect, useRef } from "react";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

import {
  // CircularProgress,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
  Box,
} from "@mui/material";
import MDButton from "components/MDButton";

import { useReactMediaRecorder } from "react-media-recorder";
import { isMobile } from "react-device-detect";

function VideoPreview({ stream, mirrored }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);
  if (!stream) {
    return null;
  }
  return (
    <video
      ref={videoRef}
      width="100%"
      autoPlay
      controls
      style={{ transform: !mirrored ? "rotateY(180deg)" : "rotateY(0deg)" }}
    >
      <track default kind="captions" srcLang="en" />
    </video>
  );
}

function VideoRecorder({ displayName, fieldRef, options }) {
  console.log(options ? "" : "");

  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [recordedVideo, setRecordedVideo] = useState(null);
  const [openRecordDialog, setOpenRecordDialog] = useState(false);

  const [cameraUsed, setCameraUsed] = useState(isMobile);
  const videoConstraints = {
    facingMode: !cameraUsed ? "user" : { exact: "environment" },
    // facingMode: "user",
    // facingMode: { exact: "environment" },
  };

  function saveMediaBlob(blobUrl, blob) {
    // console.log(blobUrl);
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      const base64data = reader.result;
      // console.log(base64data);
      setRecordedVideo(base64data);
    };
  }

  const {
    status,
    startRecording,
    stopRecording,
    mediaBlobUrl,
    previewStream,
    clearBlobUrl,
  } = useReactMediaRecorder({
    video: videoConstraints,
    onStop: (blobUrl, blob) => {
      saveMediaBlob(blobUrl, blob);
    },
  });

  return (
    <MDBox mt={3}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openRecordDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Record Video</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3} align="center">
            <MDBox>
              <Box mt={1}>
                {/* <ReactMediaRecorder
                  video
                  render={({ previewStream }) => <VideoPreview stream={previewStream} />}
                /> */}
                {status === "recording" && (
                  <VideoPreview
                    stream={previewStream}
                    mirrored={cameraUsed ? true : false}
                  />
                )}
              </Box>
              <Box mt={1}>
                <MDButton
                  size="small"
                  circular
                  variant="contained"
                  color={status === "recording" ? "error" : "success"}
                  onClick={
                    status === "recording" ? stopRecording : startRecording
                  }
                  startIcon={
                    <Icon>
                      {status === "recording" ? "stop_circle" : "play_circle"}
                    </Icon>
                  }
                >
                  {status === "recording" ? "Stop" : "Start"} Recording
                </MDButton>
                {/* &nbsp;
                <MDButton
                  size="small"
                  circular
                  variant="contained"
                  color="info"
                  onClick={() => setCameraUsed(!cameraUsed)}
                  startIcon={<Icon>flip_camera_android</Icon>}
                >
                  Switch
                </MDButton> */}
              </Box>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenRecordDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
          &nbsp;
          <MDButton
            onClick={() => {
              clearBlobUrl();
              setRecordedVideo(null);
            }}
            color="error"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>delete</Icon>
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            iconOnly
            circular
            onClick={() => {
              if (status === "recording") {
                stopRecording();
                setOpenRecordDialog(false);
                return;
              }

              if (recordedVideo === null) {
                setErrorMsg("Video recording failed");
                showFieldError(true);
                return;
              }
              setOpenRecordDialog(false);
            }}
          >
            <Icon>save</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={8} md={8} lg={8}>
            <MDTypography
              variant="h6"
              fontWeight="light"
              fontSize="small"
              mb={2}
            >
              {displayName}
            </MDTypography>
          </Grid>
          <Grid item xs={4} md={4} lg={4}>
            <MDBox align="right">
              <MDButton
                iconOnly
                size="small"
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenRecordDialog(true);
                }}
              >
                <Icon>video_camera_back</Icon>
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox mt={1}>
        {mediaBlobUrl ? (
          <video src={mediaBlobUrl} width="50%" controls>
            <track default kind="captions" srcLang="en" src={mediaBlobUrl} />
          </video>
        ) : (
          <> </>
        )}
      </MDBox>
      <input
        id={`dff_${fieldRef}`}
        type="hidden"
        name={`${fieldRef}`}
        value={recordedVideo}
      />
    </MDBox>
  );
}

// Typechecking props of the Transaction
VideoRecorder.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

VideoRecorder.defaultProps = {
  options: null,
};

VideoPreview.propTypes = {
  stream: PropTypes.string,
};

VideoPreview.defaultProps = {
  stream: null,
};

export default VideoRecorder;
